<script setup>
import {onMounted, ref} from 'vue';
import Link from "./Link.vue";
import Button from "./Button.vue";
import Icon from '../Icons/Icon.vue';
import {useI18n} from "vue-i18n";
import {ButtonType} from "@Common/Composables/button-styles";

const {t} = useI18n();

defineProps({
    items: {type: Array, required: true}
});

const iconsForCalendars = {
    google: 'Icons/CalendarLinkGoogle',
    outlook: 'Icons/CalendarLinkOutlook',
    outlook_web: 'Icons/CalendarLinkOutlook',
    iCal: 'Icons/CalendarLinkApple',
};

const isListOpen = ref(false);

onMounted(() => {
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.calendar-link-content')) {
            isListOpen.value = false;
        }
    });
});

</script>
<template>
    <div class="calendar-link-content">
        <Button @click="isListOpen = !isListOpen" :type="ButtonType.SECONDARY">
            <i class="far fa-calendar-plus"/>
            {{ t('calendar_link.title') }}
        </Button>
        <div class="links-dropdown" v-show="isListOpen" @click="isListOpen = false" target="_blank">
            <Link v-for="(link, name) in items" :key="name" v-bind="link" class="calendar-link-item" @click="isListOpen = false">
                <Icon :path="iconsForCalendars[name]" class="calendar-icon"/>
                {{ t('calendar_link.' + name) }}
            </Link>
        </div>
    </div>
</template>

<style lang="scss">

.calendar-link-content {
    position: relative;
    display: inline-block;
    margin-bottom: 2.5rem;

    .btn {
        margin: 0;
    }

    .links-dropdown {
        position: absolute;
        border: 1px solid var(--gray-200);
        padding: 5px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        list-style-type: none;
        background: white;
        min-width: 100%;
        top: 100%;
        box-shadow: 0 2px 8px 0px rgba(0, 0, 0, 0.1);

        .calendar-link-item {
            border-radius: 3px;
            display: flex;
            color: var(--gray-500);
            font-weight: 500;
            width: 100%;
            line-height: 3.5rem;
            gap: 10px;
            align-items: center;
            padding: 0 5px;

            &:hover {
                background: var(--gray-200);
                color: var(--primary);
                text-decoration: none;
                font-weight: 600;
            }

            .calendar-icon {
                height: 22px;
                width: 22px;
                flex-shrink: 0;
            }
        }
    }
}
</style>